// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3L0pf","inputWrap":"styles_inputWrap__2GxBs","input":"styles_input__3Lk4u"};